const FormatsTime: string[] = [
    'HH:mm',
    'hh:mm A',
    'HH:mm:ss',
    'hh:mm:ss A'
];

export default FormatsTime;